function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "67.2",
  cy: "180.5",
  r: "21.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2 254.9h255.1v28.3H14.2zM250 .2l-6.6 19.2c-2.3 5.5-7.7 9-13.7 9h-59.8v28.5h39.7l-21.2 102.7-69.2-26.3-19.3-41.1h27.7V63.9H35.4v28.3h32.9L81 119.1c-15.1-4.1-32.2-1.6-46.9 7.1-16.7 9.8-27.9 26.2-30 43.8-4.5 38.5 23 73.3 61.5 77.8 2.7.3 5.4.5 8.2.5h139.5c21.2 0 38.3-17.1 38.3-38.3 0-15.5-9.3-29.4-23.6-35.4l-.2-.1-12.3-4.7L239 56c14.1-3 25.7-12.8 31-26.2L279.7.2H250zM217.2 201c5 2.2 7.2 7.9 5.1 12.9-1.6 3.6-5.1 5.9-9 5.9H73.8c-23 0-41.6-18.6-41.6-41.6 0-1.6.1-3.2.3-4.8 1-8.8 7.1-17.3 16.1-22.6 5.3-3.2 11.5-5 17.7-5.1 3.4 0 6.8.6 9.9 1.9l141 53.4z"
})));